// Returns { days, hours, minutes } between two dates
function durationGetter(startDate, endDate) {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diff = end - start;
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  return { days, hours, minutes };
}

// src/functions/classes.js

const mapFirebaseError = (errorCode) => {
    switch (errorCode) {
      case 'auth/email-already-in-use':
        return 'Email already in use. Please use another email or login';
      case 'auth/invalid-email':
        return 'Invalid email format. Please check and try again';
      case 'auth/operation-not-allowed':
        return 'Operation not allowed. Please contact support';
      case 'auth/user-disabled':
        return 'Your account has been disabled. Contact support for assistance';
      case 'auth/wrong-password':
        return 'Incorrect password. Please try again';
      case 'auth/user-not-found':
        return 'User not found. Please check your credential';
      case 'auth/network-request-failed':
        return 'Network error. Check your internet connection and try again';
      case 'auth/invalid-credential':
        return 'Invalid credentials. Please verify and try again';
      case 'auth/too-many-requests':
        return 'Too many requests. Please try again late.';
      case 'auth/requires-recent-login':
        return 'Requires recent login. Please sign in again';
      // Firestore/DB errors
      case 'unavailable':
      case 'failed-precondition':
      case 'aborted':
      case 'deadline-exceeded':
      case 'internal':
      case 'resource-exhausted':
      case 'cancelled':
        return 'Database connection error. Please check your network or try again later';
      default:
        return 'Error. Please try again';
    }
  };

// Reusable ripple effect for all UI
function addRippleEffect(e) {
  const button = e.currentTarget;
  // Ensure the parent is positioned and overflow is hidden for proper ripple containment
  if (button.style.position === '' || button.style.position === 'static') {
    button.style.position = 'relative';
  }
  if (button.style.overflow !== 'hidden') {
    button.style.overflow = 'hidden';
  }
  const circle = document.createElement('span');
  circle.className = 'popupbox-btn-ripple';
  const diameter = Math.max(button.clientWidth, button.clientHeight);
  const radius = diameter / 2;
  circle.style.width = circle.style.height = `${diameter}px`;
  circle.style.left = `${e.clientX - button.getBoundingClientRect().left - radius}px`;
  circle.style.top = `${e.clientY - button.getBoundingClientRect().top - radius}px`;
  button.appendChild(circle);
  setTimeout(() => {
    circle.remove();
  }, 400);
}

function getCurrency(userDoc) {
  let country = (userDoc?.country || 'canada').toLowerCase().trim();
  const usVariants = ['us', 'usa', 'united states', 'united states of america'];
  const caVariants = ['ca', 'canada', 'can', 'canadian'];
  if (usVariants.includes(country)) return '$';
  if (caVariants.includes(country)) return 'CA$';
  return 'CA$'; // Default to CA$ if not matched
}

// Utility to send push notification to all staff of a company, with optional exclude list
export async function notifyCompanyStaff(companyID, message, title, excludeUIDs = [], excludeOnShift = false) {
  await fetch('https://capitalbeaverserver.vercel.app/api/sendnotification', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ companyID, message, title, excludeUIDs, excludeOnShift }),
  });
}

// Utility to send push notification to a specific staff
export async function notifyStaff(uid, message, title) {
  // You need to implement this endpoint in your backend if not present
  await fetch('https://capitalbeaverserver.vercel.app/api/sendnotification', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ uid, message, title }),
  });
}

export { mapFirebaseError, addRippleEffect, getCurrency, durationGetter };